export enum ColumnId {
    EVENT_DATE = 'event_date',
    EVALUATION_ID = 'evaluation_id',
    USER_NAME = 'user_name',
    MANAGER = 'manager',
    EVALUATOR = 'evaluator',
    EVALUATION_NAME = 'evaluation_name',
    SCORE = 'score',
    STATUS = 'status',
    SELECT = 'select',
}
